import React from 'react';
import { ModalTypesProps } from './Modal.types';
import { ReactComponent as CloseIcon } from './close.svg';

export const Modal: React.FC<ModalTypesProps & {
    className?: string;
}> = props => {
    const {
        isOpen,
        onClose,
        children,
        className = '',
        zeroPadding = false
    } = props;
    const [showModal, setShowModal] = React.useState(false);

    React.useEffect(() => {
        setShowModal(isOpen);
    }, [isOpen]);

    const handleClose = React.useCallback(() => {
        setShowModal(false);
        onClose();
    }, [onClose]);

    React.useEffect(() => {
        if (showModal) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }

        return () => {
            document.body.classList.remove('overflow-hidden');
        };
    }, [showModal]);

    const modalBody = () => {
        return (
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-grey-800 outline-none focus:outline-none w-[524px]">
                <div className="relative flex justify-end px-[15px] py-[5px]">
                    <div
                        onClick={handleClose}
                        className="h-[35px] w-[35px] cursor-pointer rounded-full hover:bg-black flex justify-center items-center"
                    >
                        <CloseIcon className="h-[15px] w-[15px]" />
                    </div>
                </div>
                <div
                    className={`${
                        zeroPadding ? 'p-0' : 'px-[26px] pt-0 pb-[26px]'
                    } `}
                >
                    {children}
                </div>
            </div>
        );
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
                className="absolute inset-0 bg-black/50"
                onClick={handleClose}
                aria-hidden
            />
            {modalBody()}
        </div>
    );
};
